import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Button, Spinner, Modal, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getStateListById, saveStateData, updateStateData } from "../../redux/actions/StateActions";
import FormInput from "../../Components/FormInput";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import { getAllCityStateWiseList, getAllStateList } from "../../redux/actions/MasterActions";
import Preloader from "../../Components/Preloader";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import '../../styles/common.css'

const API_KEY = "AIzaSyD5L3M2Nl4wn3coWVJlI06RjT50l44FMu8";

const AddState = ({ show, onHide, editId }) => {
  const { t } = useTranslation();
  const [showModel, setShowModel] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [placeData, setPlaceData] = useState({});
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    stateReducer: {
      loadingState,
      errorsState,
      stateLists,
      changedStateStatus,
    },
    masterReducer: {
      loadingMaster,
      masterStateLists,
      masterCityStateWiseLists,
    },
  } = useSelector((state) => state);

  const [validated, setValidated] = useState(false);
  

  useEffect(() => {
    setFormData({})
    if(editId) {
      dispatch(getStateListById(auth?.token, editId));
    }
  }, [auth, editId]);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if(editId){
      dispatch(updateStateData(auth?.token, formData, editId));
    } else {
      dispatch(saveStateData(auth?.token, formData));
    }
  };

  
  useEffect(() => {
    if(editId && stateLists && Object.keys(stateLists).length > 0) {
      setFormData({
        state_code: stateLists?.state_code,
        state_name: stateLists?.state_name,
      });
    }
  }, [stateLists]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0 && errors?.status === 401) {
      dispatch(logout());
      toast.error(errors?.data?.message);
      onHide(); // Close modal on logout
    }
  }, [errors, dispatch, onHide]);


  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  
  useEffect(() => {
    if (changedStateStatus?.success) {
    onHide()
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedStateStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_STATE_STATUS' });
    }
    setFormData({
      state_code: '',
      state_name: '',
    });
  }, [changedStateStatus, dispatch]);


  return (
    <Modal show={show} onHide={onHide} size="md" backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>{(editId && stateLists && Object.keys(stateLists).length > 0) ? t("Update State") : t("Add State")}</Modal.Title>
      </Modal.Header>
        <Modal.Body>
            {(errorsState?.data?.data?.errors?.[0]?.message || errorsState?.data?.message) && (
              <div className="alert alert-danger">
                {errorsState?.data?.data?.errors?.[0]?.message || errorsState?.data?.message}
              </div>
            )}
          <Row>
          
            <Col lg={12}>
                <FormInput
                  label={t("State Code")}
                  type="text"
                  errors={errorsState?.data}
                  value={formData.state_code}
                  name="state_code"
                  required={true}
                  onChange={inputHandler}
                  containerClass={"mb-3"}
                />
              </Col>

              <Col lg={12}>
                <FormInput
                  label={t("State Name")}
                  type="text"
                  errors={errorsState?.data}
                  value={formData.state_name}
                  name="state_name"
                  required={true}
                  onChange={inputHandler}
                  containerClass={"mb-3"}
                  disabled={!!editId}
                />
              </Col>
          </Row>
          <div className="d-flex justify-content-center">
            {loading ? 
              <Button color="primary" disabled>
                <Spinner animation="border" size="sm" />
                {t("Please wait ...")}
              </Button>
            :
              <Button type="button" onClick={(e) => handleSubmit(e)} disabled={loading}>
              {(editId && stateLists && Object.keys(stateLists).length > 0) ? t("Update") : t("Add")}
              </Button>
            }
          </div>
        
      </Modal.Body>
      {loadingState && <Preloader />}
    </Modal>
  );
};

export default AddState;
